<!-- Main container -->
@if (specs$ | async; as specs) {
  <div class="layout-col full">
    <elder-table
      class="flex"
      matSort
      [data]="specs"
      [selectionMultiEnabled]="true"
      [selectionVisible]="true"
    >
      <elder-data-toolbar
        *elderTableToolbar
        [canMore]="false"
        [canAdd]="true"
        [canRemove]="true"
        (requestNew)="onNew($event)"
        (requestRemove)="onRemove($event)"
      >
      </elder-data-toolbar>
      <!-- icon -->
      <ng-container matColumnDef="icon">
        <th mat-header-cell *matHeaderCellDef style="width: 50px"></th>
        <td mat-cell *matCellDef="let spec">
          <div class="place-start-center">
            <mat-icon>label</mat-icon>
          </div>
        </td>
      </ng-container>
      <!-- property Column -->
      <ng-container matColumnDef="property">
        <th mat-header-cell *matHeaderCellDef>{{ 'properties.property' | translate }}</th>
        <td mat-cell *matCellDef="let spec">
          <mat-form-field elderDense>
            <elder-select
              appPropertySelect
              name="property"
              required
              [kinds]="propertyKinds"
              valueAsId
              (entityChange)="spec.property = $event"
              [(ngModel)]="spec.propertyId"
            >
              <div *elderSelectValue="let prop" class="layout-col">
                <span style="line-height: 20px">{{ prop.description }}</span>
                <span class="text-body-small">{{ prop.id }}</span>
              </div>
              <app-property-browser *elderSelectionModelPopup class="flex" [kinds]="propertyKinds">
              </app-property-browser>
            </elder-select>
          </mat-form-field>
        </td>
      </ng-container>
      <!-- input required Column -->
      <ng-container matColumnDef="inputRequired">
        <th mat-header-cell *matHeaderCellDef style="width: 10%">
          {{ 'context.input-required' | translate }}
        </th>
        <td mat-cell *matCellDef="let spec">
          <mat-checkbox name="inputRequired" [(ngModel)]="spec.inputRequired"> </mat-checkbox>
        </td>
      </ng-container>
      <!-- single selection Column -->
      <ng-container matColumnDef="singleSelection">
        <th mat-header-cell *matHeaderCellDef style="width: 10%">
          {{ 'context.single-selection' | translate }}
        </th>
        <td mat-cell *matCellDef="let spec">
          <mat-checkbox
            name="singleSelection"
            [disabled]="!PropertyUtil.supportsSingleSelectionSetting(spec?.property?.type)"
            [(ngModel)]="spec.singleSelection"
          >
          </mat-checkbox>
        </td>
      </ng-container>
    </elder-table>
  </div>
}
